import React, { useState } from 'react'
import { Modal, ModalHeader, ModalFooter, ModalContent, ProductCare } from '@sainsburys-tech/bolt'

import { trackProductCareLightBoxOpen } from './helpers/productCareTracking'

const ProductCareModal = ({
  show,
  hostPartNumber,
  hostProductName,
  hostPrice,
  synapticaId,
  warrantyItem,
  warrantyAttr = {},
  warrantyPartNumber,
  productQuantity,
  closeModal,
  addToTrolley,
  careType
}) => {
  const [hasAgreeterms, setHasAgreeTerms] = useState(false)
  const { title: warrantyProductName, price: warrantyPrice } = warrantyAttr

  const modalId = 'product-care-modal'
  const modalTitle = 'We’ll cover it, so you don’t have to'
  const modalFocus = '.ac-drawer__heading'

  const attPartNumber = warrantyPartNumber ? [hostPartNumber, warrantyPartNumber] : hostPartNumber

  const contentAttr = {
    hostPartNumber,
    hostProductName,
    hostPrice,
    warrantyItem,
    quantity: productQuantity,
    warrantyName: warrantyProductName,
    warrantyPrice,
    onlyWarranty: false,
    dataTest: 'product-care-content',
    careType
  }
  return (
    careType !== 'jewellery' && (
      <Modal
        id={modalId}
        focusElement={modalFocus}
        show={show}
        onClose={closeModal}
        onOpen={trackProductCareLightBoxOpen(
          hostPartNumber,
          hostPrice,
          productQuantity,
          warrantyPartNumber,
          warrantyAttr
        )}
        height='auto'
        data-test='product-care-modal'
      >
        <ModalHeader>{modalTitle}</ModalHeader>
        <ModalContent>
          <ProductCare.ProductCareContent {...{ ...contentAttr }} />
        </ModalContent>
        <ModalFooter>
          <ProductCare.ProductCareFooter
            synapticaId={synapticaId}
            addToTrolley={addToTrolley}
            setHasAgreeTerms={setHasAgreeTerms}
            partNumbers={attPartNumber}
            hasAgreeTerms={hasAgreeterms}
            overwriteAddToTrolley={false}
            data-test='product-care-modal-footer'
            leafletCopy='Terms & Conditions'
          />
        </ModalFooter>
      </Modal>
    )
  )
}

export default ProductCareModal
